import { useContext } from 'react';

import { ContainerWidthContext } from './ContainerWidthContext';

/**
 * Returns the **approximate** container width provided by the nearest `<ContainerWidthContext.Provider>` component.
 * IMPORTANT: This value must ONLY be compared against CoreUI breakpoints to determine a responsive "range", the number
 * itself will only be updated as it crosses CoreUI breakpoint thresholds and may not be used in pixel calculations.
 *
 * All CoreUI AppLayout columns and other layered surfaces (Panel, ModalDialog, etc.) will provide this context.
 * Other layered surfaces external to CoreUI, like the SuiteHeader panels, will not have this context
 * available. If this context is necessary then the feature would need to wrap itself in a
 * `<ContainerWidthContext.Provider>` component use `useLayoutContainerQuery` to provide its value.
 *
 * @deprecated Please use `useContainerSize`.
 */
export const useContainerWidth = (): number => useContext(ContainerWidthContext);
